<div class="h-full overflow-y-auto flex-1">
  @for (station of stations(); track station.id) {
    <app-station-card [station]="station"></app-station-card>
  }
</div>
